import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Login from './pages/Login';
import Register from './pages/Register';
import Profile from './pages/Profile';
import PublicProfile from './pages/PublicProfile';
import PreviewProfile from './pages/PreviewProfile';
import AllProfiles from './pages/AllProfiles';
import Feedback from './components/Feedback';
import { AuthGuard } from './components/AuthGuard';
import { AdminRoute } from './components/AdminRoute';
import AdminDashboard from './pages/AdminDashboard';
import { AuthProvider } from './contexts/AuthContext';
import { WallpapersProvider } from './contexts/WallpapersContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { OnboardingProvider } from './contexts/OnboardingContext';
import OnboardingGuide from './components/OnboardingGuide';
import LegalNotice from './pages/LegalNotice';
import Subscribe from './pages/Subscribe';
import ForgotPassword from './pages/ForgotPassword';
import { Marketing } from './pages/admin/Marketing';

function App() {
  return (
    <ThemeProvider>
      <Router future={{
        v7_startTransition: true,
        v7_relativeSplatPath: true
      }}>
        <AuthProvider>
          <OnboardingProvider>
            <WallpapersProvider>
              <div className="min-h-screen bg-gray-50 flex flex-col">
                <Navbar />
                <OnboardingGuide />
                <main className="flex-grow">
                  <Routes>
                    <Route path="/" element={<AuthGuard><Home /></AuthGuard>} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/register" element={<Register />} />
                    <Route path="/forgot-password" element={<ForgotPassword />} />
                    <Route
                      path="/profile"
                      element={
                        <AuthGuard requireAuth>
                          <Profile />
                        </AuthGuard>
                      }
                    />
                    <Route
                      path="/profile/preview"
                      element={
                        <AuthGuard requireAuth>
                          <PreviewProfile />
                        </AuthGuard>
                      }
                    />
                    <Route
                      path="/subscribe"
                      element={
                        <AuthGuard requireAuth>
                          <Subscribe />
                        </AuthGuard>
                      }
                    />
                    <Route path="/p/:username" element={<PublicProfile />} />
                    <Route path="/all-profiles" element={<AllProfiles />} />
                    <Route path="/mentions-legales" element={<LegalNotice />} />
                    <Route path="/retours" element={<Feedback />} />
                    <Route
                      path="/admin"
                      element={
                        <AdminRoute>
                          <AdminDashboard />
                        </AdminRoute>
                      }
                    />
                    <Route
                      path="/admin/marketing"
                      element={
                        <AdminRoute>
                          <Marketing />
                        </AdminRoute>
                      }
                    />
                  </Routes>
                </main>
                <Footer />
                <Toaster position="top-right" richColors />
              </div>
            </WallpapersProvider>
          </OnboardingProvider>
        </AuthProvider>
      </Router>
    </ThemeProvider>
  );
}

export default App;